import { FigureOptions, FigureType, Point, Segment } from 'peaks.js';
import { ServerEvent } from './store';

export function mapToServerEvent(event: FigureOptions, primaryAnalysisSetId: string, eventTypeId: string, waveform: string): ServerEvent {
    if (event.figureType == FigureType.Point) {
        return {
            AnalysisSetId: primaryAnalysisSetId,
            EventTypeId: eventTypeId,
            RawStart: waveform === 'CWFT_RAW' ? (event as Point).time + event.multiDayOffset : null,
            ProcessedStart: waveform === 'CWFT_PROCESSED' ? (event as Point).time : null,
            SensorProcessedStart: waveform === 'CWFT_SENSOR_PROCESSED' ? (event as Point).time : null,
            vtaCt1Start: waveform === 'CWFT_VTA_CT1' ? (event as Point).time : null
        };
    } else {
        return {
            AnalysisSetId: primaryAnalysisSetId,
            EventTypeId: eventTypeId,
            RawStart: waveform === 'CWFT_RAW' ? (event as Segment).startTime + event.multiDayOffset : null,
            RawEnd: waveform === 'CWFT_RAW' ? (event as Segment).endTime + event.multiDayOffset : null,
            ProcessedStart: waveform === 'CWFT_PROCESSED' ? (event as Segment).startTime : null,
            ProcessedEnd: waveform === 'CWFT_PROCESSED' ? (event as Segment).endTime : null,
            SensorProcessedStart: waveform === 'CWFT_SENSOR_PROCESSED' ? (event as Segment).startTime : null,
            SensorProcessedEnd: waveform === 'CWFT_SENSOR_PROCESSED' ? (event as Segment).endTime : null,
            vtaCt1Start: waveform === 'CWFT_VTA_CT1' ? (event as Segment).startTime : null,
            vtaCt1End: waveform === 'CWFT_VTA_CT1' ? (event as Segment).endTime : null,
        };
    }
}

